module.exports = __webpack_public_path__ + "img/bill1.db2c344d.png";